import { lazyNamed } from 'src/utils/lazyNamed.ts';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet.tsx'), 'Helmet'),
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),

  AdMedia: lazyNamed(() => import('./containers/AdMedia/index.tsx'), 'AdMedia'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMedia/containers/AdMediaHistory.tsx'), 'AdMediaHistory'),

  AdPrices: lazyNamed(() => import('./containers/AdPrices/index.tsx'), 'AdPrices'),
  AdPriceForm: lazyNamed(() => import('./containers/AdPrices/containers/AdPriceForm/index.tsx'), 'AdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./containers/AdPrices/containers/AdPriceHistory.tsx'), 'AdPriceHistory'),

  AdTypes: lazyNamed(() => import('./containers/AdTypes/index.tsx'), 'AdTypes'),
  AdTypeHistory: lazyNamed(() => import('./containers/AdTypes/containers/AdTypeHistory.tsx'), 'AdTypeHistory'),

  Placements: lazyNamed(() => import('./containers/Placements/index.tsx'), 'Placements'),
  PlacementHistory: lazyNamed(() => import('./containers/Placements/containers/PlacementHistory.tsx'), 'PlacementHistory'),

  Products: lazyNamed(() => import('./containers/Products/index.tsx'), 'Products'),
  ProductForm: lazyNamed(() => import('./containers/Products/containers/ProductForm/index.tsx'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./containers/Products/containers/ProductHistory.tsx'), 'ProductHistory'),
};
